module.exports = __webpack_public_path__ + "static/media/lineto-circular-pro-book.9d1891cc.ttf";